export default __webpack_public_path__ + "static/media/5426.e57ef153.png";